<template lang="pug">
  router-view
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
  name: 'QcqPage'
})
</script>

<style lang="stylus" scoped>

</style>